import {createStore} from 'devextreme-aspnet-data-nojquery';
import useGetToken from './useGetToken';
import {ensureSessionOrRedirect} from '../../helpers/session';

function useLoadPost(
  url: string,
  key: string | string[],
  params: Object | undefined = undefined,
  allowAdd: boolean = true,
  allowEdit: boolean = true,
  allowDelete: boolean = true,
) {
  const token = useGetToken();
  const dataSource = createStore({
    key: key,
    loadUrl: url,
    loadMethod: 'POST',
    deleteUrl: allowDelete ? url : undefined,
    insertUrl: allowAdd ? url : undefined,
    updateUrl: allowEdit ? url : undefined,
    loadParams: params,
    onBeforeSend: (_, options) => {
      if (!ensureSessionOrRedirect()) {
        (options as any).cancel = true;
        return;
      }
      options.headers = {Authorization: `Bearer ${token}`};
    },
  });
  return dataSource;
}

export default useLoadPost;
